import { apiPost } from '@utils/http';

export default class YotpoService {
    static createReferralCoupon(isRef: boolean): Promise<Response> {
        return apiPost('yotpo/create-referral-coupon', {'is_ref': isRef});
    }
}